// Fire and forget ping to the native app host, which opens the SAM chat and sends the
// question as the first message. `ReactNativeWebView` only exists inside the app WebView,
// and the app ignores the message when chat is off. Omitting the question just opens the
// chat, so the user can ask their own.
export const askSam = (question?: string) =>
  window.ReactNativeWebView?.postMessage(
    JSON.stringify({ action: "askSam", question }),
  );
